<template>
  <div class="reception-container">
    <template v-if="pageShow">
      <van-sticky>
        <head-bar type="primary" title="参会信息" @onClickLeft="onClickLeft" />
      </van-sticky>
      <div class="head-banner">
        <Banner :active="false" />
        <div class="title-wraper">
          <div class="title">尊敬的参会嘉宾：</div>
          <div class="text">
            您好！欢迎您莅临 2026岳麓大会，为了给您带来更好的参会体验，请仔细阅读以下温馨提示。
          </div>
        </div>
      </div>
      <!-- <div class="basic-wraper">
        <div class="basic-title">
          <van-divider content-position="left" :hairline="false">
            <div class="title-text">会议地点</div>
          </van-divider>
        </div>
        <p>梅溪湖金茂精选酒店（具体安排详见2023互联网岳麓大会日程）</p>
      </div> -->

      <!-- <div class="basic-wraper">
        <div class="basic-title">
          <van-divider content-position="left" :hairline="false">
            <div class="title-text">会议地点</div>
          </van-divider>
        </div>
        <div class="normal"> <van-icon name="hotel-o" /> 【梅溪湖金茂精选酒店】</div>
        <div class="normal">电话：0731-88698888</div>
        <div class="normal">地址：湖南省长沙市岳麓区梅溪湖环湖路1177号</div>
        <div class="tips">温馨提示：</div>
        <div class="tips">分会场地点详情日程。另因疫情防控需要，入住长沙酒店均需出示通信行程绿码方可办理入住手续。</div>
      </div> -->

      <div class="basic-wraper traffic" v-if="true">
        <div class="basic-title">
          <van-divider content-position="left" :hairline="false">
            <div class="title-text">会场导航：</div>
          </van-divider>
        </div>
        <div class="map-container" @click="handleGoMap">
          <img
            src="https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202609201440408871571.jpg"
            alt=""
          />
          <img
            src="https://sn202108-1305501521.cos.ap-shanghai.myqcloud.com/202609211957486987242.png"
            alt=""
          />
          <div class="text-wraper">
            <!-- <span>开幕式 | 岳麓论坛地址：梅溪湖金茂精选酒店</span> -->
            <span @click.stop="handleGoMap">
              地图导航
              <img :src="require('@/assets/images/reception/guide.png')" alt="" />
            </span>
          </div>
        </div>
        <div v-if="false">
          <div class="basic-title">
            <van-divider content-position="left" :hairline="false">
              <div class="title-text">公共交通：</div>
            </van-divider>
          </div>
          <!-- <div class="fir-title">公共交通</div> -->
          <div class="sec-title">地铁站：</div>
          <p>2号线-梅溪湖文化艺术中心站</p>
          <div class="sec-title">公交站：</div>
          <p>株树咀站：W158路</p>
          <p>金茂广场（株树咀）站（227米）：418路</p>
          <p>文化艺术中心地铁站（333米）：418路、W158路、社区巴士11号线、W107路</p>
          <p>
            梅溪湖东地铁站（565米）：228路、68路、270路、W115路、322路、社区巴士5号线、211路、205路、371路、312路、219路、356路、319路、W158路
          </p>
          <p>梅溪湖大桥北（597米）：356路、418路、367路、319路、312路</p>
        </div>

      </div>


      <div class="basic-wraper">
        <div class="basic-title">
          <van-divider content-position="left" :hairline="false">
            <div class="title-text">温馨提示</div>
          </van-divider>
        </div>

        <div class="tips title" style="font-weight: bold">
          为了保证您能顺利参会，请您熟知以下内容：
        </div>
        <div class="tips">
          1.
          会议期间建议您着商务便装出席开幕式、岳麓论坛及相关活动。请自觉遵守会场秩序，按时参加会议，参会期间请记得将您的手机等通讯设备调至静音或振动状态。
        </div>
        <div class="tips">
          2.
          请规范佩戴证件参加大会各项活动，并配合安保检查。证件不得转借、复制、仿造和涂改。
        </div>
        <div class="tips">3. 会议期间您的贵重物品请随身携带，注意保管。</div>
        <div class="tips">4. 会议期间天气情况如下：</div>
        <div class="weather-container">
          <div class="weather-card" v-for="(day, index) in weatherData" :key="index">
            <div class="weather-date">{{ day.date }}</div>
            <div class="weather-icon">
              <i :class="day.icon"></i>
            </div>
            <div class="weather-temp">
              <span class="high">{{ day.high }}°</span>
              <span class="low">{{ day.low }}°</span>
            </div>
            <div class="weather-desc">{{ day.desc }}</div>
          </div>
        </div>

      </div>

      <div class="basic-wraper official">
        <div class="basic-title">
          <van-divider content-position="left" :hairline="false">
            <div class="title-text">岳麓大会官方微信公众号</div>
          </van-divider>
        </div>
        <p>
          请提前关注岳麓大会官方微信公众号，大会组委会重要通知、日程安排、动态等信息将由官方微信公众号推送和提供服务。
        </p>
        <div class="qr-code">
          <img
            src="https://zs202010-1300602059.cos.ap-guangzhou.myqcloud.com/202104071233547774107.png"
            alt=""
          />
          扫一扫获取更多会议信息
        </div>
      </div>

      <div class="basic-wraper">
        <div class="basic-title">
          <van-divider content-position="left" :hairline="false">
            <div class="title-text">联系我们</div>
          </van-divider>

          <div class="box1"></div>
        </div>
        <contact-list :color="$store.state.themeInfo.themeColor" />
        <br />
      </div>

    </template>

    <Map v-else />

    <float-menu />
  </div>
</template>

<script>
import Banner from "@/components/banner/index";
import floatMenu from "@/components/floatMenu/index";
import headBar from "@/components/headBar/headBar";
import ContactList from "@/components/contactList/index";
import Map from "./components/map/index";
import wx from "@/utils/wx";
export default {
  name: "reception",
  components: { floatMenu, Banner, Map, headBar, ContactList },
  data() {
    return {
      pageShow: true,
      weatherData: []
    };
  },
  created() {
    this.generateWeatherData();
  },
  methods: {
    generateWeatherData() {
      this.weatherData = [
        {
          date: '9月22日',
          icon: 'el-icon-cloudy-and-sunny',
          high: 20,
          low: 28,
          desc: '多云'
        },
        {
          date: '9月23日',
          icon: 'el-icon-cloudy-and-sunny',
          high: 19,
          low: 28,
          desc: '多云'
        },
        {
          date: '9月24日',
          icon: 'el-icon-cloudy-and-sunny',
          high: 21,
          low: 27,
          desc: '多云'
        }
      ];
    },
    handleGoMap() {
      // this.$router.push("/map/" + this.$store.state.miceInfo.miceLink);
      wx.openLocation(28.228365, 112.831004, "世界计算·长沙智谷“云脑”", "世界计算·长沙智谷“云脑”");
    },
    onClickLeft() {
      this.$router.push("/index/" + this.$store.state.miceInfo.miceLink);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.van-divider--content-left::before {
  max-width: 0;
  margin: 0;
}
.reception-container {
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: rgb(242, 248, 252);
  .basic-wraper {
    padding: 15px;
    background-color: #fff;
    margin-bottom: 10px;
    color: #666;
    font-size: 12px;
    p {
      margin: 5px 0 15px 0;
      line-height: 1.9;
    }
    p.normal {
      margin: 0;
    }
    .tips-title {
      font-weight: bolder;
    }
    .tips {
      color: rgb(226, 147, 44);
      margin: 8px 0;
    }
    .normal {
      line-height: 2;
    }
    .basic-title {
      margin-bottom: 10px;
      .van-divider {
        margin: 0;
        color: #333;
        font-size: 14px;
        font-weight: bold;
      }
      .title-text {
        display: flex;
        align-items: center;
        &::before {
          content: "";
          height: 20px;
          width: 20px;
          margin-right: 5px;
          background-image: url("~@/assets/images/reception/title-icon.png");
          background-size: 100% 100%;
          background-position: center;
        }
      }
    }
  }
  .head-banner {
    position: relative;
    margin-bottom: 10px;
    .title-wraper {
      // position: absolute;
      bottom: -125px;
      background-color: #fff;
      padding: 20px;
      border-top-left-radius: 13px;
      border-top-right-radius: 13px;
      font-size: 13px;
      color: #333;
      .title {
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }
      .text {
        text-indent: 28px;
        line-height: 1.8;
      }
      .text2 {
        //text-indent: 28px;
        line-height: 1.8;
        margin: 5px 0;
      }
    }
  }
  .traffic {
    .map-container {
      width: 100%;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.05);
      background: #fff;
      border-radius: 6px;
      display: flex;
      flex-direction: column;
      img {
        width: 100%;
        object-fit: cover;
        border-radius: 6px;
      }
      .text-wraper {
        width: 100%;
        height: 40px;
        display: flex;
        // flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        span:nth-of-type(1) {
          display: flex;
          padding: 5px 10px;
          background: #06c671;
          color: #fff;
          font-size: 12px;
          border-radius: 4px;
          align-items: center;
          img {
            margin-left: 5px;
            // height: 13px;
            height: auto;
            width: 13px;
          }
        }
      }
    }
    .fir-title {
      color: #3c97ed;
      font-size: 14px;
      margin: 15px 0;
    }
    .sec-title {
      font-weight: bold;
      font-size: 13px;
      color: #333;
    }
  }
  .official {
    .qr-code {
      display: flex;
      // margin-top: 10px;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: #f2f8fc;
      padding: 15px 0;
      img {
        height: 100px;
        width: 100px;
        margin-bottom: 10px;
      }
    }
  }
}
.sub-title {
  text-indent: 2em;
  .weight {
    font-weight: bolder;
  }
}

.weather-container {
  display: flex;
  justify-content: space-between;
  gap: 6px;
  margin: 8px 0;
  padding: 8px;
  background: #f8f9fa;
  border-radius: 6px;
  border: 1px solid #e9ecef;
}

.weather-card {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  padding: 6px 4px;
  text-align: center;
  border: 1px solid #e9ecef;
  
  .weather-date {
    font-size: 10px;
    font-weight: 500;
    color: #495057;
    margin-bottom: 4px;
  }
  
  .weather-icon {
    font-size: 16px;
    margin: 4px 0;
    color: #6c757d;
    
    i {
      display: block;
    }
  }
  
  .weather-temp {
    margin: 3px 0;
    
    .high {
      font-size: 12px;
      font-weight: 600;
      color: #495057;
      margin-right: 2px;
    }
    
    .low {
      font-size: 10px;
      color: #6c757d;
    }
  }
  
  .weather-desc {
    font-size: 9px;
    color: #6c757d;
    margin: 2px 0;
  }
}
</style>
